module.exports = __webpack_public_path__ + "static/media/rr-tab.0bc43636.png";